import { useState } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@cocoonspace/ui/components/dialog'
import { useLingui } from '@lingui/react/macro'
import { PenIcon, TriangleAlertIcon } from 'lucide-react'

import { InfosPersoForm } from '~/domains/account/components/personal-infos/infos-perso-form'
import { useUserContext } from '~/providers/user-provider'
import { formatPersonName } from '~/utils/format-person-name'

const UpdateDialog = () => {
	const { t } = useLingui()
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Dialog
			onOpenChange={setIsOpen}
			open={isOpen}
		>
			<DialogTrigger asChild>
				<Button
					className='ml-auto'
					size='sm'
					variant='link'
				>
					<PenIcon className='mr-1' />

					{t`Modifier`}
				</Button>
			</DialogTrigger>

			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t`Informations personnelles`}</DialogTitle>
				</DialogHeader>

				<InfosPersoForm onSuccess={() => setIsOpen(false)} />
			</DialogContent>
		</Dialog>
	)
}

const ErrorContent = () => {
	const { t } = useLingui()

	return (
		<div className='text-primary flex min-w-0 items-center gap-1 gap-4 text-sm'>
			<TriangleAlertIcon
				className='!size-6 shrink-0'
				strokeWidth={1.25}
			/>

			<div className='leading-tight'>
				{t`Informations personnelles incomplètes`}
			</div>

			<UpdateDialog />
		</div>
	)
}

export interface PersoInfoDefaultValues {
	first_name?: string
	last_name?: string
	email?: string
	phone?: string
}

const PersoInfos = ({
	defaultValues,
}: {
	defaultValues?: PersoInfoDefaultValues
}) => {
	const { userQuery } = useUserContext()

	const { first_name, last_name, email, phone } = {
		...defaultValues,
		...userQuery.data,
	}

	return (
		<div className='min-w-0 text-sm'>
			<div className='truncate font-bold'>
				{formatPersonName(first_name, last_name)}
			</div>
			<div className='truncate'>{email || ''}</div>
			<div className='truncate'>{phone || ''}</div>
		</div>
	)
}

export const PersoInfosRecap = ({
	readOnly = false,
	defaultValues,
}: {
	readOnly?: boolean
	defaultValues?: PersoInfoDefaultValues
}) => {
	const { userQuery } = useUserContext()

	const isInfosPersoIncomplete =
		(!userQuery.data?.email && !defaultValues?.email) ||
		(!userQuery.data?.last_name && !defaultValues?.last_name) ||
		(!userQuery.data?.first_name && !defaultValues?.first_name) ||
		(!userQuery.data?.phone && !defaultValues?.phone)

	return (
		<div className='flex flex-col gap-1'>
			{isInfosPersoIncomplete && !readOnly ? (
				<ErrorContent />
			) : (
				<PersoInfos defaultValues={defaultValues} />
			)}

			{!readOnly && !isInfosPersoIncomplete && (
				<div className='mt-auto flex flex-row print:hidden'>
					<UpdateDialog />
				</div>
			)}
		</div>
	)
}
